// Module
var code = "<div class=\"paper-checkbox\" ng-class=\"{selected: selected}\"> <input type=\"checkbox\" id=\"{{::elId}}\" pk=\"{{::pk}}\" ng-checked=\"{{selected}}\"/> <label for=\"{{::elId}}\" ng-click=\"click($event, !selected)\"> <span class=\"first\"></span> <span class=\"check\"></span> <span class=\"box\"></span> {{::caption}} </label> </div> ";
// Exports
var _module_exports =code;;
var path = '/codebuild/output/src2905724180/src/frontend/js/directives/public/optionCheckbox.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;